import Head from 'next/head'
import styles from '@/styles/About.module.css'
import dynamic from 'next/dynamic'
const Pizza = dynamic(() => import('@/components/Pizza'))

const pizza = () => {
  // Define itemListElement array
  const itemListElement = [
    {
      '@type': 'ListItem',
      position: 1,
      url: 'https://labambi.se/pizza',
      name: 'Pizza',
      description: 'Explore our delicious pizza menu',
    },
    {
      '@type': 'ListItem',
      position: 2,
      item: {
        '@type': 'MenuItem',
        name: 'Standard Pizza',
        description: 'Our classic selection of standard pizzas',
        url: 'https://labambi.se/pizza/standard',
      },
    },
    {
      '@type': 'ListItem',
      position: 3,
      item: {
        '@type': 'MenuItem',
        name: 'Italiensk Pizza',
        description: 'Authentic Italian pizzas with traditional toppings',
        url: 'https://labambi.se/pizza/italiensk',
      },
    },
    {
      '@type': 'ListItem',
      position: 4,
      item: {
        '@type': 'MenuItem',
        name: 'Mexikansk Pizza',
        description: 'Spicy Mexican-inspired pizzas for those who like it hot',
        url: 'https://labambi.se/pizza/mexikansk',
      },
    },
    {
      '@type': 'ListItem',
      position: 5,
      item: {
        '@type': 'MenuItem',
        name: 'Pan Pizza',
        description: 'Crunchy and thick crust pizzas baked to perfection',
        url: 'https://labambi.se/pizza/panpizza',
      },
    },
  ]

  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Hela Pizza Meny</title>
        <meta
          name='description'
          content='Välkommen till [La Bambi], din oas för en pizzaupplevelse i toppklass! Här hittar du enastående pizzor gjorda med de finaste ingredienserna och bakade i pizzaugn för en perfekt krispig yta och smakrik botten. Låt dig frestas av en härlig blandning av klassiska smaker och spännande nyskapelser, och njut av en pizza som är både vacker och smakrik.'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              itemListElement: itemListElement,
            }),
          }}
        ></script>
      </Head>
      <Pizza />
    </main>
  )
}

export default pizza
